module.exports = __webpack_public_path__ + "img/group-img-default.d70e63ad.png";